module.exports = __webpack_public_path__ + "img/fill.ed9800e4.svg";